'use strict';
angular.module('productmanageWechatBindModelModule', [])
    .controller('productmanageWechatBindModelCtrl', ['$scope', '$modalInstance', 'url', function($scope, $modalInstance, url) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {    
        }

        /**
         * [cancel description] 完场绑定 刷新列表
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $modalInstance.close();
        };

        /**
         * [reBind description]再次绑定
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.reBind = function() {
            window.open(url);  
        };
    }]);
